import React from "react";

export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden>
      <defs>
        <radialGradient id="wf-orb" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#F0D492" />
          <stop offset="100%" stopColor="#E5C378" />
        </radialGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill="#0A0E1A" />
      <g stroke="#E5C378" strokeWidth="2.2" strokeLinecap="round" opacity="0.32">
        <line x1="14" y1="44" x2="50" y2="44" />
        <line x1="14" y1="37" x2="50" y2="37" />
        <line x1="14" y1="30" x2="50" y2="30" />
      </g>
      <path d="M20 48 L34 26 L44 16" fill="none" stroke="#F8F6F0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="21" cy="48" r="4.6" fill="#F8F6F0" />
      <circle cx="46" cy="14" r="9.5" fill="#E5C378" opacity="0.22" />
      <circle cx="46" cy="14" r="5.5" fill="url(#wf-orb)" />
    </svg>
  );
}

export function LogoLockup({ subtitle = "ISAIAH 60:22", compact = false }) {
  return (
    <div className="flex items-center gap-3">
      <LogoMark size={compact ? 34 : 40} />
      <div className="leading-none">
        <div className="font-display font-bold tracking-tight text-[15px] text-[#F7F5F0]">WORSHIP FLOW</div>
        <div className="text-[10px] tracking-[0.28em] text-[#E5C378]/70 mt-1">{subtitle}</div>
      </div>
    </div>
  );
}
